import React, { useState } from "react";
import info from "../../assets/info.png";
import semanticScholar from "../../assets/semantic_scholar_logo.png";
import { t } from "../../localization/localization";
import { useEffect } from "react";
import axios from "axios";

const SemanticScholar = () => {
  const [semanticScholarData, setSemanticScholarData] = useState();

  const urlSearchParams = new URLSearchParams(window.location.search);
  const locale = urlSearchParams.get("locale") ?? "tr";

  const firstId = window.location.pathname.split("/")[3];
  const secondId = window.location.pathname.split("/")[4];

  useEffect(() => {
    axios
      .get(
        `${window._env_.BASE_URL}/gcris-api/publication/external-metrics/semantic-scholar`,
        {
          params: {
            handle: `${firstId}/${secondId}`,
          },
        }
      )
      .then((res) => {
        setSemanticScholarData(res?.data);
      });
  }, []);
  return semanticScholarData ? (
    <div>
      <div
        style={{
          borderRadius: "0.4em",
          borderLeft: "4px solid #034078",
          padding: "14px",
          backgroundColor: "#CBE4DE",
          fontFamily: "Montserrat",
          fontWeight: "500",
        }}
      >
        <div style={{ paddingRight: "10px" }}>
          <img
            alt="semantic_scholar_logo"
            src={semanticScholar}
            style={{ width: "180px", objectFit: "fill" }}
          ></img>
        </div>
        <div style={{ textAlign: "center" }}>
          <p style={{ color: "#2B3467", marginBottom: "8px" }}>
            {t(locale, "/charts/handle/semantic-scholar/citationCount")}
          </p>
          <a
            target="_blank"
            style={{ color: "#2B3467" }}
            href={semanticScholarData.url}
          >
            <span>
              {semanticScholarData.citationCount}
              <img
                src={info}
                style={{ marginLeft: "4px", width: "21px", height: "21px" }}
              ></img>
            </span>
          </a>
        </div>
      </div>
    </div>
  ) : (
    <div></div>
  );
};

export default SemanticScholar;
